import { useState } from 'react';
import { ToggleTabs, ToggleTabsButton, ToggleTabsButtonsContainer, ToggleTabsContent } from '../ToggleTabs';
import { ContentContainer, RootContainer, TabsContainer } from './styled';
export function Root(props) {
    const { header, tabs, footer } = props;
    const [activeTab, setActiveTab] = useState(tabs[0].key);
    return (<RootContainer>
      {header}
      <ToggleTabs activeTab={activeTab} onSelectTab={setActiveTab}>
        <TabsContainer>
          <ToggleTabsButtonsContainer stretch>
            {tabs.map((tab) => (<ToggleTabsButton key={tab.key} tabKey={tab.key}>
                {tab.label}
              </ToggleTabsButton>))}
          </ToggleTabsButtonsContainer>
        </TabsContainer>

        <ContentContainer>
          {tabs.map((tab) => (<ToggleTabsContent key={tab.key} tabKey={tab.key}>
              {tab.content}
            </ToggleTabsContent>))}
        </ContentContainer>
      </ToggleTabs>
      {footer}
    </RootContainer>);
}
